<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-button v-if="Limits.dealer_create" type="primary" size="small" @click="ShowAddDealer">添加经销商</el-button>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="inputMore" class="input-with-select" size="small">
					    <el-select v-model="selectMore" slot="prepend" placeholder="请选择" style="width: 100px;">
					    	<el-option label="联系人" value="1"></el-option>
						    <el-option label="电话" value="2"></el-option>
						    <el-option label="经销商" value="3"></el-option>
					    </el-select>
				    	<el-button slot="append" icon="el-icon-search" @click="Find">查询</el-button>
				  	</el-input>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99.9%" :max-height="maxHeight">
			<!--<el-table-column label="gid" prop="id" width="50"></el-table-column>-->
		    <el-table-column label="经销商名称" prop="name"></el-table-column>
		    <el-table-column label="上级经销商" prop="superior.name"></el-table-column>
		    <el-table-column label="国家" prop="country" width="120"></el-table-column>
		    <el-table-column label="省份" prop="province" width="80"></el-table-column>
		    <el-table-column label="联系人" prop="contact" width="90"></el-table-column>
		    <el-table-column label="电话" prop="phone" width="120"></el-table-column>
		    <el-table-column label="邮箱" prop="email"></el-table-column>
		    <el-table-column label="操作" width="96" v-if="Limits.dealer_delete || Limits.dealer_update">
		    	<template slot-scope="scope">
		    		<el-button v-if="Limits.dealer_update" type="primary" icon="el-icon-edit" size="mini" style="padding: 7px;" @click="Change(scope.$index,scope.row)"></el-button>
		    		<el-button v-if="Limits.dealer_delete" type="danger" icon="el-icon-delete" size="mini" style="padding: 7px;" @click="Delete(scope.$index,scope.row)"></el-button>
		    	</template>
		    </el-table-column>
		    <!--<el-table-column label="二维码" width="90">
		    	<template slot-scope="scope">
		    		<el-button type="primary" plain size="mini" >二维码</el-button>
		    	</template>
		    </el-table-column>-->
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
			<el-button v-if="Limits.deleteddealer_index" type="primary" size="small" @click="ShowDeleted">显示已删除经销商</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<!--添加经销商-->
		<el-dialog title="添加经销商" :visible.sync="AddFormVisible" width="500px">
		  	<el-form :model="form">
			    <el-form-item label="经销商：" :label-width="formLabelWidth">
			      	<el-input v-model="form.dealer" auto-complete="off" placeholder="请填写经销商名称(必填)"></el-input>
			    </el-form-item>
			    <el-form-item label="上级经销商：" :label-width="formLabelWidth" >
			      	<el-select v-model="form.Updealer" placeholder="请选择上级经销商(必选)" style="width: 100%;">
				        <el-option v-for="item in Dealerlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item label="经销商国家：" :label-width="formLabelWidth" >
			      	<el-select v-model="form.countrycode" placeholder="请选择国家(必选)" style="width: 100%;" @change="CodeChange">
				        <el-option v-for="item in Country_Code" :key="item.id" :label="item.country" :value="item.code"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item id="shengfeng" label="经销商省份：" :label-width="formLabelWidth">
			      	<el-select v-model="form.Country" placeholder="请选择省份(必选)" style="width: 100%;">
				        <el-option v-for="item in country" :key="item.id" :label="item.lable" :value="item.val"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item label="联系人：" :label-width="formLabelWidth">
			      	<el-input v-model="form.name" auto-complete="off" placeholder="请填写联系人(必填)" :maxlength="10"></el-input>
			    </el-form-item>
			    <el-form-item label="电话：" :label-width="formLabelWidth">
			      	<el-input v-model="form.phone" auto-complete="off" placeholder="请填写电话(必填)" :maxlength="11"></el-input>
			    </el-form-item>
			    <el-form-item label="邮箱：" :label-width="formLabelWidth">
			      	<el-input v-model="form.email" auto-complete="off" placeholder="请填写邮箱(必填)"></el-input>
			    </el-form-item>
			    <el-form-item label="备注其他：" :label-width="formLabelWidth">
			      	<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 6}" :maxlength="50" v-model="form.more" auto-complete="off" placeholder="(选填,字数少于50字)"></el-input>
			    </el-form-item>
		  	</el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="small" type="primary" @click="Submit" :loading="Subloading">提 交</el-button>
		  </div>
		</el-dialog>
		
		<!--修改经销商信息-->
		<el-dialog title="修改经销商信息" :visible.sync="changeFormVisible" width="500px">
		  	<el-form :model="form2">
			    <el-form-item label="经销商：" :label-width="formLabelWidth">
			      	<el-input v-model="form2.dealer" auto-complete="off" placeholder="请填写经销商名称(必填)"></el-input>
			    </el-form-item>
			    <el-form-item label="上级经销商：" :label-width="formLabelWidth" >
			      	<el-select v-model="form2.Updealer" placeholder="请选择上级经销商(必选)" style="width: 100%;">
				        <el-option v-for="item in Dealerlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item label="经销商国家：" :label-width="formLabelWidth" >
			      	<el-select v-model="form2.countrycode" placeholder="请选择国家(必选)" style="width: 100%;" @change="CodeChange2">
				        <el-option v-for="item in Country_Code" :key="item.id" :label="item.country" :value="item.code"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item id="shengfeng2" label="经销商省份：" :label-width="formLabelWidth" >
			      	<el-select v-model="form2.Country" placeholder="请选择省份(必选)" style="width: 100%;">
				        <el-option v-for="item in country" :key="item.id" :label="item.lable" :value="item.val"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item label="联系人：" :label-width="formLabelWidth">
			      	<el-input v-model="form2.name" auto-complete="off" placeholder="请填写联系人(必填)" :maxlength="10"></el-input>
			    </el-form-item>
			    <el-form-item label="电话：" :label-width="formLabelWidth">
			      	<el-input v-model="form2.phone" auto-complete="off" placeholder="请填写电话(必填)" :maxlength="11"></el-input>
			    </el-form-item>
			    <el-form-item label="邮箱：" :label-width="formLabelWidth">
			      	<el-input v-model="form2.email" auto-complete="off" placeholder="请填写邮箱(必填)"></el-input>
			    </el-form-item>
			    <el-form-item label="备注其他：" :label-width="formLabelWidth">
			      	<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 6}" :maxlength="50" v-model="form2.more" auto-complete="off" placeholder="(选填,字数少于50字)"></el-input>
			    </el-form-item>
		  	</el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="small" type="primary" @click="Submitchange" :loading="SubChangeloading">提 交</el-button>
		  </div>
		</el-dialog>
		<!--已删除经销商-->
		<el-dialog title="已删除经销商" :visible.sync="DeleteVisible" :fullscreen="true" :before-close="Backchange">
			<div>
			<el-table :data="List2" border v-loading="listloading2">
			    <el-table-column label="经销商名称" prop="name"></el-table-column>
			    <el-table-column label="上级经销商" prop="superior"></el-table-column>
			    <el-table-column label="国家" prop="country" width="120"></el-table-column>
		    	<el-table-column label="省份" prop="province" width="80"></el-table-column>
			    <el-table-column label="联系人" prop="contact"></el-table-column>
			    <el-table-column label="电话" prop="phone"></el-table-column>
			    <el-table-column label="邮箱" prop="email"></el-table-column>
			    <el-table-column label="操作" width="160">
		    	<template slot-scope="scope">
		    		<el-button v-if="Limits.deleteddealer_enable" type="success" size="mini" style="padding: 7px;" @click="Open(scope.$index,scope.row)">恢复</el-button>
		    		<el-button v-if="Limits.deleteddealer_delete" type="danger" size="mini" style="padding: 7px;" @click="Remove(scope.$index,scope.row)">彻底删除</el-button>
		    	</template>
		    </el-table-column>
  			</el-table>
  		
  			<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2" :current-page="Curpage2" :total="total2" style="float:right;">
			</el-pagination>
			</el-col>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {GetDealerlist,GetDeleteddealerslist} from '../api/api';
	import {CountryCode} from '../common/js/country_code'
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:700,
				Limits:"",
				List:[],
				listloading:false,
				Pagesize:20,
				Curpage:1,
				total:1,
				AddFormVisible:false,
				changeFormVisible:false,
				Country_Code:[],
				form:{
					dealer:"",
					Updealer:"",
					name:"",
					phone:"",
					email:"",
					more:"",
					Country:"",
					countrycode:86
				},
				form2:{
					dealer:"",
					Updealer:"",
					name:"",
					phone:"",
					email:"",
					more:"",
					Country:"",
					countrycode:""
				},
				Form:{
					id:"",
					name:"",
					superior:"",
					superior_id:"",
					contact:"",
					phone:"",
					email:"",
					other:"",
					province:"",
					country:""
				},
				Form2:{
					id:""
				},
				formLabelWidth:"120px",
				Dealerlist:{},
				Subloading:false,
				SubChangeloading:false,
				DeleteVisible:false,
				List2:[],
				listloading2:false,
				Pagesize2:20,
				Curpage2:1,
				total2:1,
				quantity:0,
				inputMore:"",
				selectMore:"",
				keyword:{},
				country:[{"lable":"北京市","val":"北京市"},{"lable":"天津市","val":"天津市"},{"lable":"上海市","val":"上海市"},{"lable":"重庆市","val":"重庆市"},{"lable":"河北省","val":"河北省"},{"lable":"山西省","val":"山西省"},{"lable":"内蒙古自治区","val":"内蒙古自治区"},{"lable":"辽宁省","val":"辽宁省"},{"lable":"吉林省","val":"吉林省"},{"lable":"黑龙江省","val":"黑龙江省"},{"lable":"江苏省","val":"江苏省"},{"lable":"浙江省","val":"浙江省"},{"lable":"安徽省","val":"安徽省"},{"lable":"福建省","val":"福建省"},{"lable":"江西省","val":"江西省"},{"lable":"山东省","val":"山东省"},{"lable":"河南省","val":"河南省"},{"lable":"湖北省","val":"湖北省"},{"lable":"湖南省","val":"湖南省"},{"lable":"广东省","val":"广东省"},{"lable":"广西壮族自治区","val":"广西壮族自治区"},{"lable":"海南省","val":"海南省"},{"lable":"四川省","val":"四川省"},{"lable":"贵州省","val":"贵州省"},{"lable":"云南省","val":"云南省"},{"lable":"西藏自治区","val":"西藏自治区"},{"lable":"陕西省","val":"陕西省"},{"lable":"甘肃省","val":"甘肃省"},{"lable":"青海省","val":"青海省"},{"lable":"宁夏回族自治区","val":"宁夏回族自治区"},{"lable":"新疆维吾尔自治区","val":"新疆维吾尔自治区"},{"lable":"香港","val":"香港"},{"lable":"澳门","val":"澳门"},{"lable":"台湾省","val":"台湾省"}]
				
			}
		},
		methods:{
			ShowAddDealer(){
				this.AddFormVisible = true
			},
			CodeChange(){
					if(this.form.countrycode == 86){
						document.getElementById('shengfeng').style.display = "block"
					}else{
						document.getElementById('shengfeng').style.display = "none"
						for(var i=0;i<this.Country_Code.length;i++){
							if(this.Country_Code[i].code == this.form.countrycode){
								this.form.Country = this.Country_Code[i].country
							}
						}
					}
			},
			CodeChange2(){
					if(this.form2.countrycode == 86){
						document.getElementById('shengfeng2').style.display = "block"
					}else{
						document.getElementById('shengfeng2').style.display = "none"
						for(var i=0;i<this.Country_Code.length;i++){
							if(this.Country_Code[i].code == this.form2.countrycode){
								this.form2.Country = this.Country_Code[i].country
							}
						}
					}
			},
			Submit(){
				if(this.form.dealer && this.form.Country && this.form.countrycode && this.form.Updealer && this.form.name && this.form.phone && this.form.email){
					this.Subloading = true
					let para = {
						name:this.form.dealer,
						superior_id:this.form.Updealer,
						contact:this.form.name,
						phone:this.form.phone,
						email:this.form.email,
						other:this.form.more,
						province:this.form.Country,
						country_code:this.form.countrycode,
					}
					let ul = "/dealers?token=" + this.token
					this.axios.post(ul,para).then(res => {
						console.log(res)
						if(res.status == "201"){
							this.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
					        this.Subloading = false
					        this.AddFormVisible = false,
					        this.form.dealer = ""
							this.form.Updealer = ""
							this.form.name = ""
							this.form.phone = ""
							this.form.email = ""
							this.form.more = ""
							this.form.Country = ""
							this.form.countrycode = 86
				        	this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id"})
						}else{
							this.$message.error('对不起，操作失败。')
							this.Subloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.Subloading = false
				})
				}else{
					this.$message.error("请填写必填项！！！")
				}
			},
			ShowDeleted(){
				this.quantity = 1
				this.DeleteVisible = true
				this.GetList2(GetDeleteddealerslist,{page:this.Curpage2,token:this.token,sort:"-delete_time"})
			},
			Backchange(){
				this.DeleteVisible = false
				if(this.quantity == 2){
					this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id"})
				}
			},
			Open(index,row){
				this.listloading2 = true
				this.Form2 = Object.assign({}, row);
				let ud = '/deleteddealers/' + this.Form2.id + "/enable?token=" + this.token
				this.axios.put(ud).then(res => {
					if(res.status == "200"){
						this.$message({
			            	type: 'success',
			            	message: '操作成功!'
			          	});
			          	this.quantity = 2
			          	this.GetList2(GetDeleteddealerslist,{page:this.Curpage2,token:this.token,sort:"-delete_time"})
					}else{
						this.$message.error('对不起，请求失败。')
						this.listloading2 = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.listloading2 = false
				})
			},
			Remove(index,row){
				this.$confirm('确认彻底删除该经销商，删除后将不可恢复?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(()=>{
			    	this.listloading2 = true
					this.Form2 = Object.assign({}, row);
					let ull = "/deleteddealers/"+this.Form2.id
					this.axios.delete(ull,{params:{"token":this.token}}).then(res => {
						if(res.status == "204"){
							this.$message({
				            	type: 'success',
				            	message: '删除成功!'
				          	});
				          	this.GetList2(GetDeleteddealerslist,{page:this.Curpage2,token:this.token,sort:"-delete_time"})
						}else{
							this.$message.error('对不起，请求失败。')
							this.listloading2 = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.listloading2 = false
					})
			    }).catch(()=>{
			    	this.$message({
			        	type: 'info',
			            message: '已取消删除'
			        });   
			    })
			},
			Refresh(){
				this.inputMore = ""
				this.selectMore = ""
				this.Curpage = 1
				this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id"})
			},
			handleCurrentChange2(val){
				this.Curpage = val
				this.GetList2(GetDeleteddealerslist,{page:this.Curpage2,token:this.token,sort:"-delete_time"})
			},
			Find(){
				if(this.inputMore && this.selectMore){
					if(this.selectMore == 1){
						this.keyword = {"AND":{"contact":'~' + this.inputMore}}
					}else if(this.selectMore == 2){
						this.keyword = {"AND":{"phone":'~' + this.inputMore}}
					}else if(this.selectMore == 3){
						this.keyword = {"AND":{"name":'~' + this.inputMore}}
					}
					this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id",q:JSON.stringify([this.keyword])})
				}
			},
			handleCurrentChange(val){
				this.Curpage = val
				if(this.inputMore && this.selectMore){
					this.Find()
				}else{
					this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id"})
				}
			},
			Delete(index,row){
				this.$confirm('确认删除该经销商?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(()=>{
			    	this.listloading = true
					this.Form = Object.assign({}, row);
					let u = '/dealers/'+this.Form.id
					this.Del(u,GetDealerlist,{page:this.Curpage,token:this.token})
			    }).catch(()=>{
			    	this.$message({
			        	type: 'info',
			            message: '已取消删除'
			        });   
			    })
			},
			Change(index,row){
				this.Form = Object.assign({}, row);
				console.log(this.Form)
				this.changeFormVisible = true
				this.form2.dealer = this.Form.name
				this.form2.Updealer = this.Form.superior.id
				this.form2.name = this.Form.contact
				this.form2.phone = this.Form.phone
				this.form2.email = this.Form.email
				this.form2.more = this.Form.other
				this.form2.Country = this.Form.province
				for(var i=0;i<this.Country_Code.length;i++){
					if(this.Country_Code[i].country == this.Form.country){
						this.form2.countrycode = this.Country_Code[i].code
					}
				}
				
				if(this.Form.country != "中国"){
					document.getElementById('shengfeng2').style.display = "none"
				}
			},
			Submitchange(){
				if(this.form2.dealer && this.form2.Country && this.form2.countrycode && this.form2.Updealer && this.form2.name && this.form2.phone && this.form2.email){
					this.SubChangeloading = true
					let url = "/dealers/" + this.Form.id + "?token=" + this.token
					let para = {
						name:this.form2.dealer,
						superior_id:this.form2.Updealer,
						contact:this.form2.name,
						phone:this.form2.phone,
						email:this.form2.email,
						other:this.form2.more,
						province:this.form2.Country,
						country_code:this.form2.countrycode,
					}
					this.axios.put(url,para).then(res => {
						console.log(res)
						
						if(res.status == "200"){
							this.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
				        this.SubChangeloading = false
				        this.changeFormVisible = false,
				        this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id"})
						}else{
							this.$message.error('对不起，请求失败。')
							this.SubChangeloading = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.SubChangeloading = false
					})
				}else{
					this.$message.error("请填写必填项！！！")
				}
			},
		},
		created(){
			this.Country_Code = CountryCode
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetDealerList(GetDealerlist)
			this.GetList(GetDealerlist,{page:this.Curpage,token:this.token,sort:"id"})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// DealerManagement.vue?12e0b39a